/**
 * Footer Configuration Constants
 * Contains carousel texts and animation timing settings
 */

export const CAROUSEL_TEXTS = [
  "Troubleshoot Complex Issues",
  "Recommendations at Every Ticket Progression",
  "Customer Configuration Context",
  "Product Version Awareness",
  "80%+ Recommendations Accuracy",
  "Automated Diagnostic Collection",
  "First Response with Probing Questions",
  "Integrated With Your Product Backend",
  "APIs and MCP Servers",
  "Ticket Contextual Search",
  "Maximized Self Service",
  "Auto-Create Knowledge Articles",
  "In-Product Support",
  "Auto Resolve",
  "Predictive Alerts Handling",
  "Predictive Tier Advancement",
  "Ticket Lifecycle Management",
  "Queue Management",
  "Backlog Management",
  "Educate Support Engineers",
  "QC Before Every Response",
  "Real Time Customer Sentiment",
  "Predict Escalations",
  "Hyper Care for New Release",
  "Hyper Care for New Customer",
  "Hyper Care for New Product",
  "CAP Management",
  "Lab Equipment Management",
  "Hiring Plans with What-if Scenarios",
  "Duty Charts",
  "Troubleshooting Map for Service Partners",
  "Strategic Intelligence",
  "Deployed Within Your VPC",
  "Your Own Local LLM",
  "Turnkey Solution",
  "AI Infused Within Your Current Tools",
  "Outcome Based Pricing"
];

export const CAROUSEL_CONFIG = {
  visibleMs: 2000,      // Time each text stays visible
  transitionMs: 450,    // Must match --duration in CSS
  threshold: 0.3,       // Intersection observer threshold
  rootMargin: '0px 0px -100px 0px' // Start a bit before footer is fully visible
};

